<template>
    <div class="special-request">
        <ButtonLink size="m" :onClick="toggleSpecialRequest">
            {{ t({ key: 'shared.special_request_headline' }) }}
        </ButtonLink>

        <TransitionExpand>
            <div v-if="showSpecialRequest">
                <Textarea
                    v-model="pax.SpecialRequest"
                    :noResize="true"
                    :rows="6"
                    :placeholder="
                        t({
                            key: 'shared.special_request_placeholder',
                        })
                    " />
            </div>
        </TransitionExpand>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType, ref } from 'vue';
    import { HotelPax } from '@/api/Cart/cart.interfaces';
    import { t } from '@shared/helpers/translation';
    import Textarea from '@ui/components/FormV2/Fields/Textarea/Textarea.vue';
    import TransitionExpand from '@ui/components/TransitionExpand/TransitionExpand.vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';

    export default defineComponent({
        name: 'SpecialRequest',
        methods: { t },
        components: { ButtonLink, TransitionExpand, Textarea },
        props: {
            pax: { type: Object as PropType<HotelPax>, required: true },
        },
        setup(props) {
            const showSpecialRequest = ref(props.pax.SpecialRequest || false);

            function toggleSpecialRequest() {
                showSpecialRequest.value = !showSpecialRequest.value;
            }

            return {
                showSpecialRequest,
                toggleSpecialRequest,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './SpecialRequest';
</style>
